import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { FormattedDate } from 'react-intl';

import { Card, CardMedia, CardTitle } from 'material-ui/Card';
import { ListItem } from 'material-ui/List';

import TimeLineIcon from 'material-ui/svg-icons/action/timeline';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import InfoIcon from 'material-ui/svg-icons/action/info';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import PrivateIcon from 'material-ui/svg-icons/action/lock';
import SkillIcon from 'material-ui/svg-icons/social/public';

import LinearProgress from 'material-ui/LinearProgress';

import { DateStyles } from '../../constants/CentricConstants';
import { statusColours } from '../../constants/ColourConstants';

import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';

const style = {
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0,
    },
    menuItem: {
        color: '#CC0000',
    },
    iconButton: {
        marginRight: 0,
    },
    listItem: {
        padding: '2px',
    }
};

const getActions = (row, auth) => {

    const infoLink     = `/dashboard/course/${row.id}`;
    const activityLink = `/dashboard/course/${row.id}/activity`;

    return [
        {
            link: infoLink,
            label: 'Preview',
            icon: <InfoIcon />
        },
        {
            type:'divider'
        },
        {
            link: activityLink,
            label: 'Activity',
            icon: <TimeLineIcon />,
            condition: {
                show:  auth.canEdit(row.access),
                roles: [ROLES.MANAGER]
            }
        },

    ];
};

class CourseCard extends Component {

    render() {

        const row = this.props;

        const infoLink = `/dashboard/course/${row.id}`;
        const menuItems = buildContextMenu((this.props.actions || getActions(row, this.context.auth)), this.context.auth);

        let listItemProps = {
            key: row.id,
            style: style.listItem,
            primaryText: (<Link to={infoLink} className="primaryText" />)
        };

        let displayDuration = '';
        const duration =  Number(row.duration) || 0;
        if (duration > 0) {
            let hours = Math.floor( duration / 60);
            let minutes = duration % 60;

            if (hours > 0) {
                displayDuration = hours + 'h';
                if (minutes > 0) {
                    displayDuration += ' ' + minutes + 'm';
                }
            } else if (minutes > 0) {
                displayDuration = minutes + 'm';
            }
            displayDuration = ' - ' + displayDuration;
        }

        let description = (row.type + displayDuration);




        let iconGroup = [];
        if (row.visibility === 'private') {
            iconGroup.push(<PrivateIcon className="icon-small" key="visibility" />);
        }

        if (row.skillId) {
            iconGroup.push(<SkillIcon className="icon-small" key="skill" />);
        }

        if (row.loading) {

            listItemProps.secondaryText = <div><LinearProgress mode="indeterminate"/></div>;

        } else if (row.secondaryText) {

            listItemProps.secondaryText = <Link to={infoLink} className="secondaryText">{row.secondaryText}</Link>;
            listItemProps.secondaryTextLines = (row.secondaryTextLines || 2);

        } else {

            const released = new Date(row.validFrom);
            listItemProps.secondaryText = (
                <Link to={infoLink} className="secondaryText">
                    <em><FormattedDate {...DateStyles.long} value={released} /> - {row.views} views</em>
                    <br />
                    {iconGroup}{description}
                </Link>
            );
            listItemProps.secondaryTextLines = 2;
        }

        if (menuItems.length > 0) {
            const topRight = {horizontal: 'right', vertical: 'top'};
            const iconMenuProps = {
                menuStyle: style.menu,
                anchorOrigin: topRight,
                targetOrigin: topRight,
                iconButtonElement: (
                    <IconButton touch={true} >
                        <MoreVertIcon color={statusColours.light} style={style.iconButton} />
                    </IconButton>
                )
            };
            listItemProps.rightIcon = (
                <IconMenu {...iconMenuProps} >
                    {menuItems}
                </IconMenu>
            );

        }

        return (
            <Card className="cent-card cent-card-6" key={row.id} >
                <div className="cent-card-flex-container">
                    <Link to={infoLink} className="cent-card-flex-title">
                        {!row.image
                            ? <CardTitle title={row.name} subtitle={row.code}/>
                            : (
                                <CardMedia
                                    className="cent-card-media"
                                    overlay={(
                                        <CardTitle
                                            title={row.name}
                                            subtitle={row.code}
                                        />
                                    )}
                                >
                                    <img src={row.image}/>
                                </CardMedia>
                            )
                        }
                    </Link>
                    <ListItem {...listItemProps} />
                </div>
            </Card>
        );
    }
}

CourseCard.contextTypes = {
    auth:   PropTypes.object.isRequired
};

export default CourseCard;
